type Note {
  note_id: ID!
  created_at: String
  modified_at: String
  title: String
  priority: Int
  status: NoteStatus
  body: String
  primary_type: NoteType
  communication_type: CommunicationType
  deadline: String
  assignee_id: String
  assignee_type: AssigneeType
  created_by_user(useClientApi: Boolean): User
  creator: NoteCreator
  case_id: ID
  case: NoteCase
  client_id: ID
  client: ClientVersion
  clients: [NoteClient!]
  property_id: ID
  mortgage_id: ID
  verification_id: ID
  organisation_ids: [ID!]!
  created_by: String
  template_id: ID
  template: NoteTemplate
  event_note: EventNote
  ui_reference: NoteUiReference
}

type NoteCreator {
  user_id: ID!
  first_name: String
  last_name: String
}

type NoteCase {
  case_id: ID
  case_type: MortgageReason
}

type NoteClient {
  client_id: ID
  first_name: String
  last_name: String
}

type NoteUiReference {
  section: UiReferenceSectionType
  entity_id: String
}

input NoteInput {
  note_id: ID
  created_at: String
  modified_at: String
  title: String
  priority: Int
  status: NoteStatus
  body: String
  primary_type: NoteType
  communication_type: CommunicationType
  deadline: String
  dueTime: String
  assignee_id: ID
  assignee_type: AssigneeType
  case_id: ID
  client_id: ID
  property_id: ID
  mortgage_id: ID
  verification_id: ID
  organisation_ids: [ID!]
  created_by: String
  template_id: ID
  event_note: EventNoteInput
  ui_reference: NoteUiReferenceInput
}

input NoteUiReferenceInput {
  section: UiReferenceSectionType
  entity_id: String
}

type GetNoteRequest {
  note_ids: [ID!]
  organisation_id: ID!
  filter_case_id: ID
  filter_client_id: ID
  filter_property_id: ID
  filter_mortgage_id: ID
  filter_assignee_id: ID
  bookmark: String
  page_size: Int
}

input GetNoteRequestInput {
  note_ids: [ID!]
  organisation_id: ID!
  filter_case_id: ID
  filter_client_id: ID
  filter_property_id: ID
  filter_mortgage_id: ID
  filter_assignee_id: ID
  bookmark: String
  page_size: Int
}

type GetFilteredNoteRequest {
  assignee_id: ID
  assignee_ids: [ID]
  primary_type: [NoteType]
  assignee_type: AssigneeType
  note_type: NoteType
  client_id: ID
  case_id: ID
  property_id: ID
  mortgage_id: ID
  sort: NoteSort
  max_deadline: String
  min_deadline: String
  status: [NoteStatus]
  template_ids: [String]
  page_size: Int
  bookmark: Int
}

type EventNote {
  event_id: String
  user_ids: [ID]
  event_type: String
  start_time: String
  end_time: String
}

input EventNoteInput {
  event_id: String
  user_ids: [ID]
  event_type: String
  start_time: String
  end_time: String
}

input GetFilteredNoteRequestInput {
  assignee_id: ID
  assignee_ids: [ID]
  assignee_type: AssigneeType
  communication_type: CommunicationType
  primary_type: [NoteType!]
  note_type: NoteType
  client_id: ID
  case_id: ID
  property_id: ID
  mortgage_id: ID
  org_ids: [ID]
  sort: NoteSort
  max_deadline: String
  min_deadline: String
  status: [NoteStatus]
  case_types: [MortgageReason]
  template_ids: [String]
  page_size: Int
  bookmark: Int
}

type GetFilteredNoteNextPage {
  bookmark: Int
}

type GetNoteResponse {
  notes: [Note!]
  next_page: GetNoteRequest
}

type GetFilteredNoteResponse {
  notes: [Note!]
  next_page: GetFilteredNoteNextPage
  filters: GetFilteredNoteRequest
}

enum NoteStatus {
  READ
  COMPLETE
  ARCHIVED
  UNREAD
}

enum NoteType {
  NOTE
  REMINDER
  REVIEW
  CALENDAR
  INVALID_NOTE_TYPE
  COMMUNICATION
}

enum CommunicationType {
  INVALID_COMMUNICATION_TYPE
  SMS
  EMAIL
  CALL
  PUSH_NOTIFICATION
  SECURE_CLIENT_COMMUNICATION
}

enum NoteSort {
  CREATED_ASC
  CREATED_DSC
  UPDATED_ASC
  UPDATED_DSC
  DEADLINE_ASC
  DEADLINE_DSC
}

enum AssigneeType {
  USER
  GROUP
  CREATOR
  CLIENT
  INVALID_ASSIGNEE_TYPE
}

enum UiReferenceSectionType {
  INVALID_SECTION
  CASE_DETAILS
  DEPOSITS
  CLIENTS
  DEPENDANTS
  ID_VERIFICATION
  CREDIT
  DEBT
  PROPERTY
  INCOME_EMPLOYMENT
  ADDITIONAL_INCOME
  EXPENDITURE
  CONVEYANCING
  SOURCING_PREFERENCES
  PROTECTION
  PROTECTION_PRE_QUALIFICATION
  EXISTING_PROTECTION
  PROTECTION_PRODUCTS
  PROTECTION_REQUIREMENTS
  PROTECTION_RECOMMENDATION
  SOURCING_PRODUCTS
  GI_PRODUCTS
  GI_SOURCING
  DOCUMENTS
  CASE_ACCOUNTING
  CONTACTS
}
